import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isTerminalPwaRoute } from "../lib/pwaRoutes";

export default function PWAManifestLink() {
  const { pathname } = useLocation();

  useEffect(() => {
    const id = "macjit-terminal-manifest";
    let link = document.getElementById(id);
    const enabled = isTerminalPwaRoute(pathname);

    if (enabled && !link) {
      link = document.createElement("link");
      link.id = id;
      link.rel = "manifest";
      link.href = "/manifest.json";
      document.head.appendChild(link);
    }

    if (!enabled && link) {
      link.remove();
    }
  }, [pathname]);

  return null;
}
